angular.module('leanlaw').controller('PeriodReportsCtrl3', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.sort = ['client.label', 'matter.label', 'user.name', 'mattertag.label'];
  $scope.reverse = false;
  $scope.format = {};
  $scope.print = function () {
    window.print();
  };
  $scope.show = dimension => $scope.zeros || dimension.data.display && dimension.data.display !== '-';
  $scope.export = function () {
    // Matter term
    const matter = $scope.me.terms.Matter;
    let exp = {};
    if ($scope.filter.primary.id === "clients") {
      // Exporting clients/matters
      exp = $scope.data.filteredClients.reduce((accum, c) => {
        let clientItem = {};
        if ($scope.clientReferences || $scope.references) {
          if ($scope.filter.include && $scope.filter.include.matters) {
            clientItem = {
              "ID": c.client.reference || "",
              "Client": c.client.name,
              [matter]: ""
            };
          } else {
            clientItem = {
              "ID": c.client.reference || "",
              "Client": c.client.name
            };
          }
        } else if ($scope.filter.include && $scope.filter.include.matters) {
          clientItem = {
            "Client": c.client.name,
            [matter]: ""
          };
        } else {
          clientItem = {
            "Client": c.client.name
          };
        }
        c.periods.forEach(p => {
          clientItem[p.period.label] = p.data.display === '-' ? 0 : p.data.display;
        });
        clientItem['Total'] = c.data.display || 0;
        accum.push(clientItem);
        if ($scope.filter.include.matters) {
          c.matters.forEach(m => {
            const matterItem = {
              "ID": m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
              "Client": "",
              [matter]: m.matter.name
            };
            m.periods.forEach(p => {
              matterItem[p.period.label] = p.data.display === '-' ? 0 : p.data.display;
            });
            matterItem['Total'] = m.data.display || 0;
            accum.push(matterItem);
          });
        }
        return accum;
      }, []);
    } else if ($scope.filter.primary.id === "accounts") {
      // Exporting users
      exp = $scope.data.filteredUsers.reduce((accum, u) => {
        let userItem = {
          "User": u.user.label || u.user.name
        };
        u.periods.forEach(p => {
          userItem[p.period.label] = p.data.display === '-' ? 0 : p.data.display;
        });
        accum.push(userItem);
        return accum;
      }, []);
    } else {
      exp = $scope.data.filteredTags.reduce((accum, u) => {
        let item = {
          "Practice Area": u.mattertag.label
        };
        u.periods.forEach(p => {
          item[p.period.label] = p.data.display === '-' ? 0 : p.data.display;
        });
        accum.push(item);
        return accum;
      }, []);
    }
    exportJson.downloadCsv(exp);
  };
  function formatDate(date) {
    return $filter("dateStandard")(new Date(date));
  }
  $scope.loading = true;
  var _query = null;
  function filterClientEntries() {
    if (!$scope.filter.primary) return; // Only run this once the filter is ready

    var query = reportsService.queryFromFilter($scope.filter);
    query.data = $scope.filter.property.data;
    query.billed = 'any';
    query.billedState = undefined;
    query.primary = $scope.filter.primary.id;
    query.secondary = 'period';
    query.reportType = 'period-report';
    query.billingType = $scope.filter.billingType && $scope.filter.billingType.filter;
    query.period = $scope.filter.timeUnit.period;
    let {
      startDate,
      endDate
    } = $scope.filter.period.range;
    if (!startDate || $scope.filter.period.range.startPeriod || $scope.filter.period.range.startPeriod) {
      startDate = $scope.filter.period.range.startPeriod.startDate;
      endDate = $scope.filter.period.range.endPeriod.endDate;
    }
    query.startDate = startDate.toNetworkDate();
    // the report ui expects the enddate to be the day after the day I am interested in (this is because we
    // are passing in a timezone with the date and so midnight on the enddate will not include that date, so we
    // add another day to the end date here)
    query.endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1).toNetworkDate();

    // This prevents reloading data when we change filters that don't impact the query
    // such as the property and matters-include filters
    if (_query && _query === JSON.stringify(query)) {
      selectProperty($scope.data);
      return;
    }
    _query = JSON.stringify(query);
    $scope.printFilterTime = `${formatDate(query.startDate)} - ${formatDate(query.endDate)}`;
    $scope.loading = true;
    singleRequest.apiCall("report").getReport(query).then(data => {
      if (!data) return;
      $scope.data = data;
      // Only the Clients view has ID columns; the Accounts and Practice Area views have no clients
      const clients = data.clients || [];
      $scope.references = clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = clients.some(c => c.client.reference);
      selectProperty($scope.data);
      $scope.loading = false;
    }).catch(err => {
      $scope.data = null;
      alerts.error(err);
      $scope.loading = false;
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    deactivate();
  });
  function selectProperty(data) {
    const props = $scope.filter.property.id.split('.');
    const p1 = props[0];
    const p2 = props[1];
    adjustData(data, p1, p2, $scope.filter.property.filter);
  }
  function adjustData(data, p1, p2, filter) {
    if (!data) return;
    const d = data.data;
    if (d) {
      const number = d[p1][p2];
      d.display = number ? $filter(filter)(number) : '-';
    }
    adjustList(data.clients, p1, p2, filter);
    adjustList(data.matters, p1, p2, filter);
    adjustList(data.users, p1, p2, filter);
    adjustList(data.periods, p1, p2, filter);
    adjustList(data.matterTags, p1, p2, filter);
  }
  function adjustList(list, p1, p2, filter) {
    if (!list) return;
    list.forEach(i => adjustData(i, p1, p2, filter));
  }
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    if (!payload) return;
    // Assigning to existing filter keeps custom filter options
    $scope.filter = Object.assign($scope.filter, payload);
    // Necessary to set this value for the requests
    $scope.filter.status = $scope.filter.archived.status;
    $scope.filter.scope = $scope.filter.filter.scope;
    filterClientEntries();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    $scope.filter = Object.assign($scope.filter, payload);
    $scope.zeros = $scope.filter.include.zeros;
    filterClientEntries();
  });

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredUsers = $filter('orderBy')($filter('filter')($scope.data.users, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredTags = $filter('orderBy')($filter('filter')($scope.data.matterTags, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('data.users', updateFiltered);
  $scope.$watch('data.matterTags', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);